import { parallaxView } from './parallax'

document.addEventListener('DOMContentLoaded', () => {
  // parallaxView()

  // // Логіка відкривання підменю на мобілках по кліку
  // console.log('srs/src/utils/index.ts addEventListener')
  // const topMenus = Array.from(document.getElementsByClassName('top-menu'));
  // console.log('topMenus', topMenus)
  // topMenus.forEach(el => {
  //   el.addEventListener('click', () => {
  //     console.log('було натиснуто на .top-menu')
  //     el.classList.toggle('is-open')
  //   })
  // })

})